<template>
  <div
    class="pickapack-message"
    :class="{ 'pickapack-message--complete': qualifies }"
  >
    <div class="pickapack-message__text body-2">
      <div
        v-if="qualifies"
        v-text="$string(
          'cart.pickapack.complete',
          { replace: { dis: discount } }
        )"
      />

      <div
        v-else-if="items.length > 1"
        v-text="$string('cart.pickapack.incomplete_multiple')"
      />

      <div
        v-else
        v-text="$string('cart.pickapack.incomplete_single')"
      />

      <div
        v-if="!qualifies"
        v-text="$string(
          'cart.pickapack.instructions',
          { replace: {
            number: remaining,
            items: itemText,
            dis: discount,
          }
          }
        )"
      />
    </div>

    <a
      v-if="!qualifies"
      class="pickapack-message__cta body-2"
      :href="`${root}collections/${collection}`"
      v-text="$string('cart.pickapack.cta')"
    />
  </div>
</template>

<script>

/**
 * Vue: Pickapack message (pickapack-message)
 * -----------------------------------------------------------------------------
 * Pick-a-Pack Message used in Cart.
 *
 * @param {Object} items - Pick a pack items in cart.
 * @param {Object} threshold - Item count to qualify for discount.
 * @param {Object} discount - Discount applied to qualifiers.
 * @param {Object} collection - collection handle for Shop All CTA.
 */
export default {
  name: 'PickapackMessage',

  props: {
    items: {
      type: Object,
      required: true,
    },
    threshold: {
      type: Number,
      default: 3,
    },
    discount: {
      type: Number,
      default: 15,
    },
    collection: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      qualifies: false,
      remaining: 0,
      itemText: 'items',
      root: window.Shopify.routes.root,
    }
  },

  computed: {

    /**
     * Compute how many PAP items are in cart.
     * @returns {Number}
     */
    count() {
      let count = 0

      this.items.forEach((item) => {
        count += item.quantity
      })

      return count
    },
  },

  watch: {
    items() {
      this.doesQualify()
    },
  },

  mounted() {
    this.doesQualify()
  },

  methods: {

    /**
     * Determine if PAP promotion applies to cart.
     */
    doesQualify() {
      this.qualifies = this.count >= this.threshold

      if (this.qualifies) {
        return
      }

      this.getRemaining()
    },

    /**
     * Get remaining number of items before promo applies.
     */
    getRemaining() {
      this.remaining = this.threshold - this.count

      if (this.remaining === 1) {
        // Compiled strings not working for these translations
        this.itemText = 'item'

      } else {
        this.itemText = 'items'
      }
    },
  },
}
</script>

<style lang="scss">
@import './pickapack-message';
</style>
